module.exports = __webpack_public_path__ + "img/Reg-10-Contribute.5f067985.svg";